<template>
    <div class="py-2">
        <div class="form-group d-flex align-items-center justify-content-between">
            <label class="mb-0" for="title">{{ trans('Name') }}:</label>
            <div class="input-group w-65">
                <input
                    name="title"
                    v-model="filter.title"
                    class="form-control"
                    @input="searchTaskName"
                    :placeholder="trans('Search')"
                    type="text"
                />
            </div>
        </div>
        <div class="form-group d-flex align-items-center justify-content-between">
            <label class="m-0" for="client_id">{{ trans('Client') }}:</label>

            <div class="input-group w-65">
                <v-select
                    :options="optionsOfClients"
                    :modelValue="selectedClient"
                    @update:modelValue="onClientSelect"
                    @search="onSearchClient"
                    :placeholder="trans('Search...')"
                    :filterable="false"
                    :getOptionKey="getClientOptionKey"
                    id="client_id"
                    label="text"
                >
                    <template v-slot:option="option">
                        <div class="d-center">
                            <span v-if="option.icon" :class="option.icon"></span>
                            {{ option.text }}
                        </div>
                    </template>
                    <template v-slot:selected-option="option">
                        <div class="selected d-center">
                            <span v-if="option.icon" :class="option.icon"></span>
                            {{ option.text }}
                        </div>
                    </template>
                    <template v-slot:no-options>
                        {{ trans('Start typing to search for') }}
                        {{ trans('Clients') }}
                    </template>
                </v-select>
            </div>
        </div>
        <div class="form-group d-flex align-items-center justify-content-between">
            <label class="mb-0" for="project_id">{{ trans('Project') }}:</label>

            <div class="input-group w-65">
                <v-select
                    :options="optionsOfProjects"
                    :modelValue="selectedProject"
                    @update:modelValue="onProjectSelect"
                    @search="onSearchProject"
                    :filterable="false"
                    :placeholder="trans('Select...')"
                    id="project_id"
                    label="text"
                >
                    <template v-slot:no-options>
                        {{ trans('Start typing to search for') }}
                        {{ trans('Projects') }}
                    </template>
                </v-select>
            </div>
        </div>
        <div class="form-group d-flex align-items-center justify-content-between">
            <label class="mb-0" for="planned_id">{{ trans('Planned') }}:</label>

            <div class="input-group w-65">
                <v-select
                    :options="optionsOfPlanned"
                    :modelValue="selectedPlanned"
                    @update:modelValue="onPlannedSelect"
                    :placeholder="trans('Select...')"
                    id="planned_id"
                    label="text"
                >
                </v-select>
            </div>
        </div>
        <div class="form-group">
            <div class="d-flex align-items-center justify-content-between">
                <label class="mb-0" for="deadline_period">{{ trans('Deadline') }}:</label>

                <div class="input-group w-65">
                    <v-select
                        :options="optionsOfDeadline"
                        :modelValue="selectedDeadlineType"
                        @update:modelValue="onChangeDeadlineType"
                        :placeholder="trans('Select...')"
                        id="deadline_period"
                        label="text"
                    >
                    </v-select>
                </div>
            </div>

            <div class="d-flex align-items-center justify-content-between mt-2">
                <v-select
                    :options="optionsOfDeadlinePeriod"
                    :modelValue="selectedDeadlinePeriod"
                    @update:modelValue="onChangeDeadlinePeriod"
                    :placeholder="trans('Select...')"
                    id="deadline_period"
                    style="width: 30% !important; height: 35px !important"
                    class="no-search"
                    label="text"
                >
                </v-select>
                <vue-flatpickr
                    :modelValue="filter.deadline.date"
                    @update:modelValue="onChangeDeadlineDate"
                    :config="config"
                    :placeholder="trans('Select date')"
                    name="deadline_date"
                    class="form-control w-65"
                    autocomplete="off"
                >
                </vue-flatpickr>
            </div>
        </div>
        <div class="form-group d-flex align-items-center justify-content-between">
            <label class="mb-0" for="deadline_period">{{ trans('Duration') }}:</label>
            <div class="d-flex align-items-center justify-content-between pl-3">
                <v-select
                    :options="optionsOfDuration"
                    :modelValue="selectedDurationType"
                    @update:modelValue="onChangeDuration"
                    :placeholder="trans('Select...')"
                    id="deadline_period"
                    style="width: 50% !important; height: 35px !important"
                    class="no-search"
                    label="text"
                >
                </v-select>

                <vue-flatpickr
                    :modelValue="filter.duration.time"
                    @update:modelValue="onChangeDurationTime"
                    :config="{
                        enableTime: true,
                        noCalendar: true,
                        dateFormat: 'H:i',
                        time_24hr: true,
                    }"
                    name="timeStart"
                    class="form-control form-control--white-background pl-1"
                    autocomplete="off"
                    style="width: 40% !important"

                >
                </vue-flatpickr>
            </div>
        </div>
        <div class="form-group d-flex align-items-center justify-content-between">
            <label class="mb-0" for="sorting">{{ trans('Sort') }}:</label>

            <div class="input-group w-65">
                <v-select
                    :options="optionsOfSorting"
                    :modelValue="selectedSorting"
                    @update:modelValue="onSortingSelect"
                    :placeholder="trans('Select...')"
                    id="sorting"
                    label="text"
                    :getOptionKey="getSortingOptionKey"
                >
                </v-select>
            </div>
        </div>
        <div class="text-right">
            <button type="button" class="btn btn-secondary btn-sm" @click.prevent="clearFilter">
                {{ trans('Clear filter') }}
            </button>
        </div>
    </div>
</template>

<script>
import VueFlatpickr from 'vue-flatpickr-component';

export default {
    components: {
        VueFlatpickr,
    },
    data() {
        return {
            filter: {
                title: '',
                client_id: 0,
                client_type: null,
                project_id: 0,
                planned_id: 0,
                deadline: {
                    type: null,
                    period: null,
                    date: null,
                },
                duration: {
                    comparison: null,
                    time: '00:00',
                },
                timer: null,
            },
            clientsCollection: [
                {
                    id: 'none',
                    type: 'none',
                    text: trans('All without client'),
                },
                {
                    id: 'all',
                    type: 'all',
                    text: trans('All with client'),
                },
            ],
            projectCollection: [
                {
                    id: 'none',
                    type: null,
                    title: trans('All without project'),
                },
                {
                    id: 'all',
                    type: null,
                    title: trans('All with project'),
                },
            ],
            selectedClient: {
                id: 0,
                text: trans('None'),
            },
            selectedProject: {
                id: 0,
                text: trans('None'),
            },
            selectedPlanned: {
                id: 0,
                text: trans('None'),
            },
            selectedDeadlineType: {
                id: 0,
                text: trans('None'),
            },
            selectedDeadlinePeriod: {
                id: 0,
                text: trans('None'),
            },
            selectedDurationType: {
                id: 0,
                text: trans('None'),
            },
            config: {
                allowInput: true,
            },
            sortBy: {
                type: null,
                direction: null,
            },
            selectedSorting: {
                id: '0',
                text: trans('None'),
            },
            optionsOfSorting: [
                {
                    id: 'task-name',
                    direction: 'ASC',
                    text: trans('Task ascending'),
                },
                {
                    id: 'task-name',
                    direction: 'DESC',
                    text: trans('Task descending'),
                },
                {
                    id: 'project-name',
                    direction: 'ASC',
                    text: trans('Project ascending'),
                },
                {
                    id: 'project-name',
                    direction: 'DESC',
                    text: trans('Project descending'),
                },
                {
                    id: 'deadline_at',
                    direction: 'ASC',
                    text: trans('Deadline ascending'),
                },
                {
                    id: 'deadline_at',
                    direction: 'DESC',
                    text: trans('Deadline descending'),
                },
                {
                    id: 'estimated_time',
                    direction: 'ASC',
                    text: trans('Estimated time ascending'),
                },
                {
                    id: 'estimated_time',
                    direction: 'DESC',
                    text: trans('Estimated time descending'),
                },
            ],
        };
    },
    props: {
        newPage: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    methods: {
        getInfoForFilters(search, client = false) {
            let url = route('task.get-filter-data');
            if (search && client) {
                url += `?search_client=${search}`;
            }
            if (search && !client) {
                url += `?search_project=${search}`;
            }
            axios
                .get(url)
                .then((response) => {
                    this.clientsCollection = this.clientsCollection.concat(response.data.clients);
                    this.projectCollection = this.projectCollection.concat(response.data.projects);
                })
                .catch((response) => {})
                .then(() => {});
        },

        onSearchClient: _.debounce(function (search) {
            if (search !== '') {
                this.clientsCollection = [
                    {
                        id: 'none',
                        type: 'none',
                        text: trans('All without client'),
                    },
                    {
                        id: 'all',
                        type: 'all',
                        text: trans('All with client'),
                    },
                ];
                this.getInfoForFilters(search, true);
            }
        }, 300),
        onSearchProject: _.debounce(function (search) {
            if (search !== '') {
                this.projectCollection = [
                    {
                        id: 'none',
                        type: null,
                        title: trans('All without project'),
                    },
                    {
                        id: 'all',
                        type: null,
                        title: trans('All with project'),
                    },
                ];
                this.getInfoForFilters(search);
            }
        }, 300),
        searchTaskName: _.debounce(function (search) {
            if (search !== '') {
                this.$emit('filter', this.queryParams, true);
            }
        }, 300),
        onClientSelect(client) {
            this.selectedClient = client;
            this.filter.client_id = client.id;
            this.filter.client_type = client.type;
            this.$emit('filter', this.queryParams, true);
        },
        getClientOptionKey(option) {
            return String(option.type) + String(option.id);
        },
        onProjectSelect(project) {
            this.selectedProject = project;
            this.filter.project_id = project.id;
            this.$emit('filter', this.queryParams, true);
        },
        onPlannedSelect(option) {
            this.filter.planned_id = option.id;
            this.selectedPlanned = option;
            this.$emit('filter', this.queryParams, true);
        },
        onChangeDeadlineType(type) {
            this.filter.deadline.type = type.id;
            this.selectedDeadlineType = type;
            this.$emit('filter', this.queryParams, true);
        },
        onChangeDeadlinePeriod(period) {
            this.filter.deadline.period = period.id;
            this.selectedDeadlinePeriod = period;
            this.$emit('filter', this.queryParams, true);
        },
        onChangeDeadlineDate(value) {
            this.filter.deadline.date = value;
            this.$emit('filter', this.queryParams, true);
        },
        onChangeDuration(duration) {
            this.filter.duration.comparison = duration.id;
            this.selectedDurationType = duration;
            this.$emit('filter', this.queryParams, true);
        },
        onChangeDurationTime(value) {
            this.filter.duration.time = value;
            window.setTimeout(() => {
                this.$emit('filter', this.queryParams, true);
            }, 2000);
        },
        onSortingSelect(sorting) {
            this.selectedSorting = sorting;
            this.sortBy.direction = sorting.direction;
            this.sortBy.type = sorting.id;
            this.$emit('filter', this.queryParams, true);
        },
        getSortingOptionKey(option) {
            return String(option.direction) + String(option.id);
        },
        clearFilter() {
            this.filter.title = '';
            this.filter.client_id = 0;
            this.filter.client_type = null;
            this.filter.project_id = 0;
            this.filter.planned_id = 0;
            this.filter.deadline.date = null;
            this.filter.deadline.period = null;
            this.filter.deadline.type = null;
            this.filter.duration.comparison = null;
            this.filter.duration.time = '00:00';

            //selection revert
            this.selectedClient = {
                id: 0,
                text: trans('None'),
            };
            this.selectedProject = {
                id: 0,
                text: trans('None'),
            };
            this.selectedPlanned = {
                id: 0,
                text: trans('None'),
            };
            this.selectedDeadlineType = {
                id: 0,
                text: trans('None'),
            };
            this.selectedDeadlinePeriod = {
                id: 0,
                text: trans('None'),
            };
            this.selectedDurationType = {
                id: 0,
                text: trans('None'),
            };
            this.selectedSorting = {
                id: 0,
                text: trans('None'),
            };
            this.$emit('filter', null, true);
        },
    },
    mounted() {
        this.getInfoForFilters();
    },
    computed: {
        queryParams: function () {
            return {
                filter: {
                    title: this.filter.title,
                    client: this.filter.client_type + '|' + this.filter.client_id,
                    project: this.filter.project_id,
                    planned: this.filter.planned_id,
                    deadline:
                        this.filter.deadline.type +
                        '|' +
                        this.filter.deadline.period +
                        '|' +
                        this.filter.deadline.date,
                    duration: this.filter.duration.comparison + '|' + this.filter.duration.time,
                },
                sort:
                    this.sortBy.direction == 'DESC'
                        ? '-' + (this.sortBy.type == null ? 'deadline_at' : this.sortBy.type)
                        : '' + (this.sortBy.type == null ? 'deadline_at' : this.sortBy.type),
            };
        },
        optionsOfClients() {
            if (this.clientsCollection.length == 0) {
                return;
            }
            let items = this.clientsCollection.map((item) => {
                return item;
            });

            items.sort((a, b) => {
                let current = a.text.toUpperCase(),
                    next = b.text.toUpperCase();

                if (current > next) return 1;
                if (current < next) return -1;

                return 0;
            });

            return items;
        },
        optionsOfProjects() {
            if (this.projectCollection.length == 0) {
                return;
            }
            let items = this.projectCollection.map((item) => {
                if (item.id == 'all' || item.id == 'none') {
                    return {
                        id: item.id,
                        text: item.title,
                    };
                } else {
                    return {
                        id: item.id,
                        text: item.title + ' (' + item.tasks_count + ')',
                    };
                }
            });
            items.sort((a, b) => {
                let current = a.text.toUpperCase(),
                    next = b.text.toUpperCase();

                if (current > next) return 1;
                if (current < next) return -1;

                return 0;
            });

            return items;
        },
        optionsOfPlanned() {
            return [
                {
                    id: 'not',
                    text: trans('Not planned'),
                },
                {
                    id: 'half',
                    text: trans('Half planned'),
                },
                {
                    id: 'fully',
                    text: trans('Fully planned'),
                },
            ];
        },
        optionsOfDeadline() {
            return [
                {
                    id: 'task',
                    text: trans('Task'),
                },
                {
                    id: 'project',
                    text: trans('Project'),
                },
            ];
        },
        optionsOfDeadlinePeriod() {
            return [
                {
                    id: 'before',
                    text: trans('Before'),
                },
                {
                    id: 'on',
                    text: trans('On'),
                },
                {
                    id: 'after',
                    text: trans('After'),
                },
            ];
        },
        optionsOfDuration() {
            return [
                {
                    id: 'less',
                    text: trans('Less'),
                },
                {
                    id: 'exactly',
                    text: trans('Exactly'),
                },
                {
                    id: 'more',
                    text: trans('More'),
                },
            ];
        },
    },
    watch: {
        newPage(value) {
            if (value == true) {
                this.$emit('filter', this.queryParams);
            }
        },
    },
};
</script>
<style lang="scss">
.w-65 {
    width: 65% !important;
}
.form-group {
    margin-bottom: 0.5rem;
}
.no-search {
    .vs__search {
        position: absolute !important;
        width: 1px !important;
        height: 1px !important;
        overflow: hidden !important;
        padding: 0 !important;
        margin: -1px !important;
        border: 0 !important;
        clip: rect(0 0 0 0) !important;
    }
    .vs__dropdown-toggle {
        height: 100%;
    }
}
</style>
